import { useFlag } from '@unleash/proxy-client-react';

const FLAG_NAME = 'marty.unleash.wiring';
export const UnleashWiringTest = () => {
  const enabledFlag = useFlag(FLAG_NAME);
  return <div className="hidden">{`${FLAG_NAME} ${enabledFlag ? 'enabled' : 'disabled'}`}</div>;
};
